import { CardContainer, SectionHeadingSkeleton } from '@/_containers';
import PhoneNumberLoading from '@/_containers/inputs/phone-number/loading';

export function ProfileRightSectionLoading() {
  return (
    <>
      <CardContainer right>
        <SectionHeadingSkeleton withRightSlot />
        <PhoneNumberLoading />
      </CardContainer>
      <CardContainer right>
        <SectionHeadingSkeleton withRightSlot />
        <PhoneNumberLoading />
      </CardContainer>
    </>
  );
}
